import axios, { AxiosRequestTransformer } from "axios";

export type ResponseStatus = 'fail' | 'ok'

const defaultTransformers = (): AxiosRequestTransformer[] => {
    const { transformRequest } = axios.defaults;
    if (!transformRequest) {
        return [];
    } else if (transformRequest instanceof Array) {
        return transformRequest;
    } else {
        return [transformRequest];
    }
};

export const RestAPI = axios.create({
    baseURL: "/conf/ajax/",
    transformRequest: [
        function (data, headers) {
            const userIdStr = "user_id";
            const userId = window.localStorage.getItem(userIdStr);
            if (userId) {
                const dataWithUserId = { ...data, [userIdStr]: +userId };
                return dataWithUserId;
            }
            return data;
        },
        ...defaultTransformers(),
    ],
});

RestAPI.defaults.headers.common = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
    "Content-Type": "application/json",
    application: "x-www-form-urlencoded",
};
